export function overwriteImage({
  imageOverwriteFeature,
  path,
  defaultSkuId,
  image,
}) {
  return imageOverwriteFeature && path.includes(imageOverwriteFeature.nValue)
    ? `//media.johnlewiscontent.com/i/JohnLewis/${defaultSkuId}${imageOverwriteFeature.postfix}?`
    : image;
}

export function overwriteSelectedSwatch({
  imageOverwriteFeature,
  path,
  selectedSwatch,
}) {
  if (imageOverwriteFeature && path.includes(imageOverwriteFeature.nValue)) {
    // eslint-disable-next-line no-param-reassign
    selectedSwatch.imageUrl = `//media.johnlewiscontent.com/i/JohnLewis/${selectedSwatch.skuId}${imageOverwriteFeature.postfix}?`;
  }
  return selectedSwatch;
}
